<script lang="ts">
  import { Button } from '$shared/components';
  import authService from '$shared/services/authService';
  import { Module } from '$shared/constants/Module';
import { ButtonSize } from '$shared/constants/ButtonSize';
import { ButtonStyle } from '$shared/constants/ButtonStyle';

  interface Props {
    loading?: boolean;
    title?: string;
    index?: number;
    hasMultipleRecords?: boolean;
    disabled?: boolean;
    onevent?: (payload: any) => void;
  }

  let {
    loading = false,
    title = '',
    index = 0,
    hasMultipleRecords = false,
    disabled = false,
    onevent
  }: Props = $props();

  let accepted = $state(false);
  const onClickCorrect = () => {
    accepted = true;
    onevent?.({ type: 'accept', index });
  };
</script>

<div class="header">
  {#if title}
    <div class="subHeader">{title}</div>
  {/if}
  {#if hasMultipleRecords}
    <div class="action">
      <Button
        name="correctMatch"
        loading={accepted && loading}
        disabled={(accepted && loading) ||
          disabled ||
          !authService.getUserRole().hasWritePermission(Module.Providers)}
        icon="icon-check"
        style={ButtonStyle.Primary}
        size={ButtonSize.Large}
        onclick={onClickCorrect}>Correct match</Button
      >
    </div>
  {/if}
</div>

<style>
  .action {
    position: absolute;
    top: 24px;
    right: 24px;
    z-index: 9;
  }
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .subHeader {
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    margin-top: 8px;
  }
</style>
